const ESTADOS = [
  "AC",
  "AL",
  "AM",
  "AP",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RO",
  "RS",
  "RR",
  "SC",
  "SE",
  "SP",
  "TO",
];

const UNIDADES = ["UN", "KG", "CX", "MT", "DZ", "LT", "PC", "SC"];

// const FORMAS_DE_PAGAMENTO = ['À Vista', 'Cheque', 'Duplicata', 'Consignado', 'Cartão de Crédito', 'Cartão de Débito', 'Boleto', 'Depósito Bancário', 'Boleto/Cheque', 'Boleto Bancário', 'Fiado'];
const FORMAS_DE_PAGAMENTO = [
  // 'À Vista',
  "PIX",
  "Dinheiro",
  "Cartão de Crédito",
  "Cartão de Débito",
  "Depósito Bancário",
  "Transferência",
  "Cheque",
  "Devedor",
  "Separado",
  "Duplicata",
  "Boleto Bancário",
  "Haver",
];

const FORMAS_DE_PAGAMENTO_CAIXA = [
  "PIX",
  "Dinheiro",
  "Depósito Bancário",
  "Cheque",
  "Transferência",
  "Marcadoria",
  "Cartão de Crédito",
  "Cartão de Débito",
  "Boleto Bancário",
  "Haver",
];

const PRAZOS_DE_PAGAMENTO = [
  { text: "30/60", value: 1 },
  { text: "30/60/90", value: 2 },
  { text: "30/60/90/120", value: 3 },
  { text: "15/30/45", value: 4 },
];

const TIPO_PESSOA = [
  { text: "Física", value: "F" },
  { text: "Jurídica", value: "J" },
];

const GRUPOS_PRODUTOS = [
  { text: "Calças", value: "1" },
  { text: "Bermudas", value: "2" },
  { text: "Camisas", value: "3" },
];

const MODELOS_ETIQUETAS = [
  { text: "AUTO ADESIVA 1 COLUNA (100x30x01)", value: "100x30x01" },
  { text: "AUTO ADESIVA 2 COLUNAS - 40x25x02", value: "40x25x02" },
  { text: "TAGs 3 COLUNAS - 35x60x03", value: "35x60x03" },
];

const PAGINACAO = [
  15,
  20,
  30,
  50,
  { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
];

const ITENS_POR_PAGINA = 50;

const PERFIS = ["Administrador", "Gerente", "Vendedor"];

const STATUS_CHEQUE = ["Em Caixa", "Devolvido", "Repassado", "Compensado"];

const SITUACAO = ["Todos", "Abertos", "Pagos", "Vencidos", "A Vencer"];

const TIPO_LANCAMENTO = ["Entrada", "Saída"];

const FOOTER_PROPS = {
  "items-per-page-options": [10, 20, 30, 50, 100],
};

const TABLE_OPTIONS = {
  itemsPerPage: 10,
  page: 5,
};

const CELULAR_MASK = "(##)#####-####";
const TELEFONE_MASK = "(##)####-####";
const CEP_MASK = "#####-###";

const MESES = [
  { text: 'Janeiro', value: 1 },
  { text: 'Fevereiro', value: 2 },
  { text: 'Março', value: 3 },
  { text: 'Abril', value: 4 },
  { text: 'Maio', value: 5 },
  { text: 'Junho', value: 6 },
  { text: 'Julho', value: 7 },
  { text: 'Agosto', value: 8 },
  { text: 'Setembro', value: 9 },
  { text: 'Outubro', value: 10 },
  { text: 'Novembro', value: 11 },
  { text: 'Dezembro', value: 12 },
];

const STATUS_PRODUTO = {
  UNCHANGED: 'unchanged',
  CHANGED: 'changed',
  NEW: 'new',
  DELETED: 'deleted',
};

const TIPO_CONTA_BANCARIA = [
  { text: "Corrente", value: "corrente" },
  { text: "Poupança", value: "poupanca" },
];

const TIPOS_CHAVE_PIX = {
  telefone: "Telefone",
  email: "E-mail",
  cpf: "CPF",
  cnpj: "CNPJ",
  aleatoria: "Aleatória"
}

const globals = {
  ESTADOS,
  UNIDADES,
  FORMAS_DE_PAGAMENTO,
  FORMAS_DE_PAGAMENTO_CAIXA,
  PRAZOS_DE_PAGAMENTO,
  TIPO_PESSOA,
  GRUPOS_PRODUTOS,
  PAGINACAO,
  ITENS_POR_PAGINA,
  PERFIS,
  STATUS_CHEQUE,
  SITUACAO,
  TIPO_LANCAMENTO,
  FOOTER_PROPS,
  TABLE_OPTIONS,
  CELULAR_MASK,
  TELEFONE_MASK,
  CEP_MASK,
  MESES,
  STATUS_PRODUTO,
  MODELOS_ETIQUETAS,
  TIPO_CONTA_BANCARIA,
  TIPOS_CHAVE_PIX
};

export { globals };

export default {
  install: (Vue, options) => {
    Vue.prototype.$globals = globals;
  },
};
